import React, { ChangeEvent, useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SearchResultForDropDownList } from '../../interfaces';

interface SearchableDropdownProps {
  controlId: string;
  label: string; // Allow for string or number types that can be converted to Date
  textplaceholder: string; // Allow for string or number types that can be converted to Date
  dropdownplaceholder: string; // Allow for string or number types that can be converted to Date
  searchMethod: (term: string) => Promise<SearchResultForDropDownList[]> | SearchResultForDropDownList[];
  handleSetValue: (ean: string) => void;
  defaultValue?: string;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({ controlId, label, dropdownplaceholder, searchMethod, handleSetValue, defaultValue }) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState(defaultValue || "");
  const [searchResults, setSearchResults] = useState<SearchResultForDropDownList[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // Initialisation de la valeur par défaut
  useEffect(() => {
    if (defaultValue) {
      setSearchTerm(defaultValue);
    }
  }, [defaultValue]);

  const performSearch = async (term: string) => {
    const results = await searchMethod(term);
    if (Array.isArray(results)) {
      setSearchResults(results);
      setShowDropdown(results.length > 0);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value === "") {
      handleSetValue("");
    }

    if (value.length >= 2) {
      performSearch(value);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelectChange = (label: string) => {
    setSearchTerm(label); // Set the search term to the label of the selected result
    handleSetValue(label); // Pass the id or another relevant value to the handleSetValue function
    setShowDropdown(false);
  };

  return (
    <Form.Group controlId={controlId} className="position-relative">
      <Form.Label className="fs-4 fw-medium text-secondary mt-3">{t(label)}</Form.Label>
      <Form.Control type="text" name="targetEAN" value={searchTerm} onChange={handleInputChange} className="text-secondary bg-light fw-medium" placeholder={t(dropdownplaceholder)} autoComplete="off" />
      {showDropdown && searchResults.length > 0 && (
        <div className="dropdown-menu show w-100 shadow-sm" style={{ top: '100%', position: 'absolute', zIndex: 1050, maxHeight: '200px', overflowY: 'auto' }}>
          {searchResults.map((result, index) => (
            <Button key={index} className="dropdown-item text-secondary fw-medium" onClick={() => handleSelectChange(result.label)}>{result.label}</Button>
          ))}
        </div>
      )}
    </Form.Group>
  );
};

export default SearchableDropdown;